// extracted by mini-css-extract-plugin
module.exports = {"gridContainer":"DocumentGrid_gridContainer__OllQA","gridOverlay":"DocumentGrid_gridOverlay__2cfqo"};